/**
 * Shared Framer Motion presets — layout-safe (no layout / layoutId on block slots).
 */

export const NB_EASE = [0.22, 1, 0.36, 1]
export const NB_EASE_OUT = [0.16, 1, 0.3, 1]

export const NB_SPRING_SOFT = {
  type: 'spring',
  stiffness: 400,
  damping: 32,
  mass: 0.78,
}

export const NB_SPRING_SNAPPY = {
  type: 'spring',
  stiffness: 540,
  damping: 36,
  mass: 0.68,
}

export const NB_TAB_SWITCH = {
  initial: { opacity: 0.72 },
  animate: { opacity: 1 },
  transition: { duration: 0.2, ease: NB_EASE },
}

export const NB_SECTION_ENTER = {
  initial: { opacity: 0, y: 10, scale: 0.994 },
  animate: { opacity: 1, y: 0, scale: 1 },
  transition: {
    ...NB_SPRING_SOFT,
    opacity: { duration: 0.26, ease: NB_EASE },
  },
}

/** Launchpad → notebook block insert */
export const NB_BLOCK_SPAWN = {
  initial: { opacity: 0, y: 14, scale: 0.97, filter: 'blur(2px)' },
  animate: { opacity: 1, y: 0, scale: 1, filter: 'blur(0px)' },
  transition: {
    ...NB_SPRING_SOFT,
    filter: { duration: 0.22, ease: NB_EASE },
  },
}

export const NB_ROW_ENTER = (index = 0) => ({
  initial: { opacity: 0, y: 6, scale: 0.99 },
  animate: { opacity: 1, y: 0, scale: 1 },
  transition: {
    ...NB_SPRING_SNAPPY,
    delay: Math.min(index * 0.038, 0.16),
  },
})

export const NB_EXPAND = {
  initial: { height: 0, opacity: 0 },
  animate: { height: 'auto', opacity: 1 },
  exit: { height: 0, opacity: 0 },
  transition: { duration: 0.28, ease: NB_EASE },
}

export const NB_FADE = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.18, ease: NB_EASE },
}
